import logo from 'images/communities/Sacramento/logo2.png'
import secondaryLogo from 'images/communities/Sacramento/logo.svg'
import backgroundImage2 from 'images/communities/Sacramento/background-image.svg'
import loginBackgroundImg from 'images/communities/Sacramento/background-image.jpg'
import favicon from 'images/communities/Sacramento/favicon.ico'
import homeLogo from 'images/home/community-logos/sacramento.png'
import { SURVEY_QUESTIONS } from 'types'
import videoImage from 'images/map/video/sacramento-video-button-image.svg'

const config = {
  subdomain: 'sacramento',
  name: 'Sacramento',
  position: 6,
  partnerSupportEmail: 'artlook@cityofsacramento.org',
  schoolSupportEmail: 'artlook@cityofsacramento.org',
  artistSupportEmail: 'artlook@cityofsacramento.org',
  stylesheet: 'sacramento.scss',
  mapRedirectPath: '',
  organizationUrl: 'https://www.cityofsacramento.gov/ccs/oac',
  faqUrl:
    'https://drive.google.com/file/d/1oHweE17iNSQ0-KSlDtvRGyvRuRT2pYCd/view?usp=sharing',
  mapEnabled: true,
  schoolPortalEnabled: true,
  partnerPortalEnabled: true,
  partnerProfileCompletionEnabled: false,
  schoolProfileCompletionEnabled: false,
  teachingArtistProfileCompletionEnabled: false,
  showRecentLoginOnPublicPage: true,
  portalSignInEnabled: true,
  googleLoginEnabled: true,
  partnerProgramsEnabled: true,
  educatorEnabled: false,
  notificationsEnabled: true,
  notificationListSize: -1,
  dataDashboardEnabled: true,
  id: 8,
  partnerRegisterEnabled: false,
  schoolDisabled: true,
  partnerPhotoVideoEnabled: true,
  partnerProgramPhotoEnabled: true,
  showPartnerHomeApplicationLink: true,
}

config.pendingApprovalModal = {
  title: 'Your Account Is Under Review',
  body: `<div><p>Thanks for creating your account! Please note, your profile will not appear on the map until it has been approved by our team.</p><p>For now, we recommend not spending too much time setting everything up until you receive your approval email. Once your account is approved, you'll receive an email notification letting you know you're live on the map and ready to go.</p><p>If you have any questions, please contact our support team at ${config.partnerSupportEmail}.</p></div>`,
}

// ----- Teaching Artist -----
config.teachingArtist = {
  enabled: true,
  registerEnabled: false,
  provideOwnPrograms: true,
  photoVideoEnabled: true,
  programPhotoEnabled: true,
  showHomeApplicationLink: true,
}

config.teachingArtistRegister = {
  fields: {
    firstName: {
      visible: true,
      required: true,
    },
    lastName: {
      visible: true,
      required: true,
    },
    email: {
      visible: true,
      required: true,
    },
    address: {
      visible: true,
      required: true,
    },
    yearsOfExperience: {
      visible: true,
      required: true,
    },
    description: {
      visible: true,
      required: true,
    },
    website: {
      visible: true,
      required: false,
    },
    disciplines: {
      visible: true,
      required: true,
    },
    profilePicture: {
      visible: true,
      required: false,
    },
    backgroundCheckFile: {
      visible: false,
      required: false,
    },
    pronouns: {
      visible: false,
      required: false,
    },
    demographic: {
      visible: false,
      required: false,
    },
    idealWage: {
      visible: true,
      required: false,
    },
  },
}

// Teaching Artist Application (multi-step form) – step 1 fields
config.teachingArtistApplication = {
  fields: {
    firstName: { visible: true, required: true },
    lastName: { visible: true, required: true },
    email: { visible: true, required: true },
    address: { visible: true, required: true },
    phoneNumber: { visible: true, required: true },
    artistBiography: { visible: true, required: true },
    disciplines: { visible: true, required: true },
    website: { visible: true, required: false },
    demographic: { visible: true, required: false },
    anyGivenChildParticipant: { visible: true, required: false },
    profilePicture: { visible: true, required: true },
    spotlightVideo: { visible: true, required: false },
    spotlightImages: { visible: true, required: true },
  },
}

// Partner Application (multi-step form) – step 1 fields
config.partnerApplication = {
  fields: {
    organizationName: { visible: true, required: true },
    dbaName: { visible: true, required: true },
    organizationMission: { visible: true, required: true },
    address: { visible: true, required: true },
    contactFirstName: { visible: true, required: true },
    contactLastName: { visible: true, required: true },
    contactEmail: { visible: true, required: true },
    contactPhoneNumber: { visible: true, required: true },
    disciplines: { visible: true, required: true },
    organizationWebsite: { visible: true, required: false },
    leadershipCharacteristics: { visible: true, required: false },
    anyGivenChildParticipant: { visible: true, required: true },
    organizationLogo: { visible: true, required: false },
    spotlightVideo: { visible: true, required: false },
    spotlightImages: { visible: true, required: true },
  },
}

// ----- SEARCH -----
config.search = {
  options: {
    blockList: ['networks', 'creativeSchoolsCategory'],
  },
  schoolSearchFilters: [
    'network',
    'creativeSchoolsCategory',
    'instructorsTeaching',
    'schoolType',
    'organizationPartnersCount',
    'programsOffered',
    'disciplineInterests',
    'resourceProgramOutcomeInterests',
    'coursesOffered',
    'studentDemographics',
    'schoolDistrict',
    'openToPartnerships',
  ],
  map: {
    center: { lat: 38.3937983, lng: -121.4421321 },
  },
}

// ----- BRANDING -----

config.defaultBranding = {
  className: 'sac-community',
  favicon,
  mapLogo: {
    src: logo,
    alt: "Sacramento's homepage",
    link: config.organizationUrl,
  },
  secondarySideBySideLogo: {
    src: secondaryLogo,
    alt: 'City of Sacramento',
  },
  secondaryFooterLogo: {
    src: secondaryLogo,
    alt: 'City of Sacramento',
  },
  videoImpage: {
    src: videoImage,
    alt: 'Video Image',
  },
  homeLogo: {
    src: homeLogo,
    alt: 'Sacramento Metropolitan Arts Commission',
  },
  communityLogo: {
    src: logo,
    alt: 'Artlook Schools',
  },
  dashboardHeader: {
    src: backgroundImage2,
    alt: '',
  },
  loginBackgroundImg: {
    src: loginBackgroundImg,
    alt: '',
  },
  mapHero: {
    src: backgroundImage2,
    alt: '',
  },
}

// ----- DISPLAY TEXT -----

/**
 * This object overrides the display text that is defined globally with string values that are
 * specific to the organization. Mustache-esque templating is available for dynamic strings using
 * {{ insertFieldName }} for interpolation.
 */

config.displayText = {
  tagline:
    "Let's increase access to arts education for all Sacramento County students.",
  application: {
    tagline: 'Apply today',
  },
  map: {
    title: 'artlook Map: Increasing Arts Education in Sacramento',
    searchHeader: 'Find Arts Providers in Sacramento',
    welcomeSearchHeader: 'Explore Arts Education in Sacramento',
    welcomeHeader: `
      How Does artlook Help Arts Education in <span>${config.name}<span>?
    `,
    explorationHeader:
      '<h1>What can you do on artlook<sup>®</sup> Sacramento</h1>',
    explorationSubTitle: 'Here are some examples...',
    welcomeMessage: `
      <div class="columns">
        <div class="column-left">
          <p>
           artlook<sup>®</sup> ${config.name} is a free, online hub designed to strengthen arts education by connecting 
           teaching artists and cultural organizations with schools, community sites, and senior-serving organizations 
           across our region. It helps educators and program leaders engage learners of all ages—children, youth, and 
           older adults—in meaningful, culturally relevant arts experiences. 
          </p>
          <p>
            Developed by Ingenuity in Chicago and customized locally through a collaboration among teaching artists, arts 
            and cultural organizations, educators, and the City of Sacramento, artlook provides an up-to-date 
            picture of the people, places, and programs that support arts education and creative aging throughout ${config.name}. 
          </p>
        </div>
        <div class="column-right">
          <p>
            In addition to the publicly available Directory on this site, artlook<sup>®</sup> supports 
            the City of Sacramento’s ability to offer data analysis, reporting, and targeted initiatives 
            that inform planning, advocacy, and investment. These tools help strengthen a diverse, equitable, 
            and sustainable arts education ecosystem for schools, communities, and lifelong learners.  
          </p>
          <p>
            The City of Sacramento invites teaching artists and arts partners to join artlook<sup>®</sup> 
            ${config.name} each year. To learn more about eligibility and how to get on the map, contact 
            <a href="mailto:${config.schoolSupportEmail}" target="_blank" rel="noopener noreferrer">${config.schoolSupportEmail}</a>
          </p>
        </div>
      </div>
    `,
    findSchoolsCard: {
      title: `Find Arts Organizations to work with your school`,
      text: `
        <p>
          If you're a school, community center, local agency, or other community site in need of supplemental arts programs, 
          such as residencies and assemblies, use the search feature to find arts organizations offering these programs and connect!
        </p>
      `,
    },
    findProgramsCard: {
      title: `Find an Independent Teaching Artists to work with`,
      text: `
        <p>
          If you’re a school, community center, local agency, or other community site  in need of workshops or residencies 
          and would like to work with local artists providing these services, use the search for possible partners.
        </p>
      `,
    },
    findDataCard: {
      title: `Resources and Partnerships for Teaching Artists`,
      text: `
        <p>
          If you’re an independent teaching artist, you can use the art organization search tool to find arts organizations 
          you may want to collaborate or work for and seek out resources to advance your arts education practice.
        </p>
      `,
    },
    justExploreCard: {
      title: `Resources and Partnerships for Organizations`,
      text: `
      <p>
        If you’re an arts organization needing to hire or contract with local independent teaching artists, 
        use the search tool to find artists available for hire.
      </p>
    `,
    },
    videoWelcomeTitle: `Welcome To artlook<sup>®</sup> ${config.name}`,
    videoWelcomeMessage: `
      <p>
        artlook Sacramento is a <b>free</b>, <b>publicly available</b>, <b>searchable directory</b>—the only one of its 
        kind in Sacramento—dedicated to highlighting local arts education offerings from teaching artists and 
        arts organizations across our community.
      </p>
      <p>
        Use the Search tool above to explore arts education programs and resources available to schools and 
        community sites throughout Sacramento County.
      </p>
      <p>
        The Directory provides an up-to-date picture of what’s happening in arts education, along with direct contact information 
        to connect with teaching artists and arts organizations.
      </p>
      <br/>
      <p>
        Explore, connect, and help bring the arts to more of our community.
      </p>
    `,
    videoModal: {
      width: '560',
      height: '315',
      iframeTitle: 'Sacramento artlook map welcome video',
      srcUrl: 'https://www.youtube.com/embed/18mtFEfXmjc?controls=0',
    },
    footer: {
      learnMoreAboutArtlook: 'Learn more about artlook<sup>®</sup>',
      contact: "We'd love to hear from you",
    },
    metricScore: {
      title: 'Creative Schools Certification',
      message: `
        The Creative Schools Certification is at the core of the CPS
        Arts Education Plan. It is a summary measure of the quality
        of arts education available in each school, and therefore
        functions as a decision-making roadmap for stakeholders
        working to expand the arts in schools.
      `,
      basedOnSchoolYear:
        ' The Certification information here is based on the {{ schoolYearNumber }} school year.',
    },
  },
  surveyCompletionModal: `
    <h2>Survey Complete!</h2>
    <br />
    <p>Thank you for completing this year's survey! Your responses help us paint a more comprehensive picture of arts education and can help us connect public schools such as yourselves with quality arts programs. You can download a copy of your survey responses on the survey page.</p>
    <br />
    <p><b>Next up: Give your Profile a quick refresh! Update your current year data to make sure everything's spot-on. The more accurate your info, the easier it is to connect with new partners and get discovered by the right ones.</b></p>
  `,
  partnerPortal: {
    dashboard: {
      welcomeMessage: `
        <p>
          <strong><em>artlook<sup>®</sup> Sacramento</em> is YOUR gallery for arts education data</strong>
        </p>
        <p>
          <em>artlook<sup>®</sup> Sacramento</em> is the only platform of its kind that combines data from Sacramento-area public schools and arts education program providers (like you!). The goal is to build direct connections between arts providers and schools to expand equitable access to quality arts education programming for EVERY student in our community.
        </p>
        <p>
          <strong>To get started, follow the links in the boxes below to share your organization's program and school partnership information. Make sure to complete all sections of your profile.</strong>
        </p>
        <p>
        If you have any questions or need assistance, please contact <a href="mailto:${config.partnerSupportEmail}" target="_blank" rel="noopener noreferrer">${config.partnerSupportEmail}</a>.
        </p>
      `,
    },
  },
  schoolPortal: {
    dashboard: {
      welcomeMessage: `
        <h3><em>artlook<sup>®</sup> Sacramento</em> is YOUR gallery for arts education data</h3>
        <p>
          <em>artlook<sup>®</sup> Sacramento</em> is the only platform of its kind that combines data from Sacramento-area public schools (like you!) and arts education program providers. The goal is to build direct connections between arts providers and schools to expand equitable access to quality arts education programming for EVERY student in our community.
        </p>
        <p>
          <strong>To get started, complete both steps below: Update Your School Profile to share your partnership interests for the current school year, and Complete the Annual Survey (once it goes live) to share information about your school's arts education offerings from the previous school year.</strong>
        </p>
        <p>
        If you have any questions or need assistance, please contact <a href="mailto:${config.schoolSupportEmail}" target="_blank" rel="noopener noreferrer">${config.schoolSupportEmail}</a>.
        </p>
      `,
    },
  },
  survey: {
    getStarted: `
      <h2><strong>Welcome to the {{ surveySchoolYearNumber }} artlook Survey!</strong></h2>
      <p>
        Through this annual survey, you will be asked to share information about arts education staffing and instruction at your school, partnerships with arts partners (i.e., arts organizations), and how your school budgets and plans for the arts.
      </p>
      <p>
        As you work on the {{ surveySchoolYearNumber }} survey, please be sure to frequently save your responses to each question to avoid losing information. You are not required to complete your survey in one session; saving your responses as you go will allow you to return at any time to complete or edit your survey before submitting.
      </p>
      <p>
        Please feel free to reach out to <a href="mailto:${config.schoolSupportEmail}" target="_blank" rel="noopener noreferrer">${config.schoolSupportEmail}</a> with any questions!
      </p>
    `,
    courses: {
      classMoniker: 'course',
      coursesNote: `
        <p>
          <strong>Note on courses:</strong> An arts course meets the following criteria: (1) it is offered to students during the school day, (2) it is categorized as an arts course rather than another content area (e.g., math, science), and (3) it is taught by a credited arts instructor.
        </p>
      `,
      minutesNote: `
        <p>
          <strong>Note on minutes:</strong> Please calculate average weekly minutes for elementary courses across the entire school year. If a course only meets for part of the year, include this adjustment in your estimate. For example:
        </p>
        <p>
          <ul class="bulleted-list">
            <li>A course that meets for 90 minutes per week in quarters 1 and 2, and not at all in quarters 3 and 4, would have an average of 45 weekly minutes. (90 / 2 = 45)</li>
            <li>A 120-minute course that meets once every three weeks across the school year would have an average of 40 weekly minutes. (120 / 3 = 40)</li>
            <li>A course that met for 90 minutes per week in semester 1 and 180 minutes per week in semester 2 would have an average of 135 weekly minutes. (90 / 2 + 180 / 2 = 135)</li>
          </ul>
        </p>
      `,
    },
    staffingQuestion: {
      modalMessage: `
        <p>
          <strong>Note on instructors</strong>: Restrict the list of instructors in your school to those teaching an arts course during the school day. Note that district-run/district-managed schools require arts instructors to hold a state certification or endorsement in one of the following arts disciplines: visual arts, media arts, music, theater, and/or dance. Charter schools, contract schools, and Pre-K-only schools do not have this requirement. If itinerant teachers teach at your school, please report those individuals as well.
        </p>
        <p>
          <strong>Note on part/full-time status</strong>: Please select Full Time if a teacher had full-time status at your school for the entire school year. If a teacher was part-time at your school for all or part of the year, or full-time for only part of the year, please select Part Time.
        </p>
        <p>
          <strong>Note on disciplines</strong>: The Primary Focus of each instructor is required. You may optionally list a Secondary Focus as well. Please also select the “Classroom/non-arts teacher?” button if the instructor is not primarily an arts instructor (e.g., non-arts, general education teacher teaching arts courses).
        </p>
      `,
      displayOptions: {
        showClassNumber: true,
      },
    },
    instructorQuestion: {
      displayOptions: {
        showInstructorEmail: true,
      },
    },
    scholarshipQuestion: {
      displayOptions: {
        showExample: true,
      },
    },
  },
  artistPortal: {
    dashboard: {
      welcomeMessage: `
        <h3>Welcome to artlook – A Home for Teaching Artists!</h3>
        <p>
          We're excited to have you join our vibrant community of teaching artists, educators, and organizations passionate about arts education. Whether you're here to showcase your talents, connect with schools and partners, or discover new opportunities, this platform is designed to support your journey
        </p>
        <p>
          Start by building your profile, sharing your experience, and exploring collaborations. Together, we can inspire creativity and make a lasting impact through the arts.
        </p>
        <p>
        If you have any questions or need assistance, please contact <a href="mailto:${config.artistSupportEmail}" target="_blank" rel="noopener noreferrer">${config.artistSupportEmail}</a>.
        </p>
      `,
    },
  },
}

// ----- SURVEY QUESTIONS CONFIG -----

const {
  APPROACHES,
  GOVERNANCE,
  OBSTACLES_SELECT,
  OBSTACLES_DESCRIBE,
  OBSTACLES_OVERCOME,
  DISTRICT_SPENDING,
  COMMUNITY_ENGAGEMENTS,
} = SURVEY_QUESTIONS

config.surveyQuestions = {
  approaches: APPROACHES.OPTIONS.PER_DISCIPLINE,
  governance: GOVERNANCE.OPTIONS.GENERAL,
  obstaclesSelect: OBSTACLES_SELECT.OPTIONS.GENERAL,
  obstaclesDescribe: OBSTACLES_DESCRIBE.OPTIONS.GENERAL,
  obstaclesOvercome: OBSTACLES_OVERCOME.OPTIONS.GENERAL,
  districtSpending: DISTRICT_SPENDING.OPTIONS.GENERAL,
  communityEngagement: COMMUNITY_ENGAGEMENTS.OPTIONS.GENERAL,
}

export default config
